import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LoginService } from 'src/app/login.service';
import { TranslatorService } from 'src/app/translator.service';

@Component({
  selector: 'app-resultshistory',
  templateUrl: './resultshistory.component.html',
  styleUrls: ['./resultshistory.component.scss'],
})
export class ResultshistoryComponent implements OnInit {

  @Input() sessionResultData;
  @Input() lang;
  @Input() class;
  @Input() teacherpath;
  @Input() testid;
  @Input() userid;
  @Input() kidid;
  @Input() isShowCase;
  @Input() testname;
  @Input() kidname;
  @Input() parentname;

  public shareBtnLabel = '';
  public tests = [];
  public sharelink = '';
  public colSize = '12';
  constructor(public translatorService: TranslatorService, public modalCtrl: ModalController, public loginService: LoginService) { }

  ngOnInit() {
    this.shareBtnLabel = this.translatorService.translate('idx', '*Distribuie arhiva rezultate');
    this.sharelink = 'https://genialii.web.app/tabs/tab1?customparam=true&viewresults=true&lang=' + this.lang + '&class=' + this.class +
      '&teacherpath=' + this.teacherpath + '&testid=' + this.testid + '&kidid=' + this.kidid + '&userid=' + this.userid
      + '&kidname=' + this.kidname + '&parentname=' + this.parentname;
      if(this.loginService.isDesktop)
      {
        this.colSize ='6';
      }
  }


  async shareResults() {
    this.shareBtnLabel = this.translatorService.translate('idx', '*Link copiat!');
    if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(this.sharelink);
      } catch (err) { }
    }
  }
  startTest(id) {
    this.modalCtrl.dismiss(id);
  }
}
